"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var FormComponentUtils_1 = require("./common/FormComponentUtils");
var ValidationMessage_1 = __importDefault(require("./common/ValidationMessage"));
var HookUtils_1 = require("../../common/HookUtils");
var FieldValidationState_1 = require("./common/FieldValidationState");
var common_1 = require("../common");
var Select = function (props) {
    var children = props.children, disabled = props.disabled, floatLabel = props.floatLabel, formControlProps = props.formControlProps, invalid = props.invalid, label = props.label, name = props.name, optionList = props.optionList, onChange = props.onChange, onBlur = props.onBlur, secondary = props.secondary, validationMessage = props.validationMessage, validationState = props.validationState, value = props.value, visuallyHiddenLabel = props.visuallyHiddenLabel, emptyState = props.emptyState, placeholder = props.placeholder;
    var _a = HookUtils_1.useStateWithSingleProp(value), optionState = _a[0], setOptionState = _a[1];
    var _b = react_1.useState(false), emptyStateSelection = _b[0], setEmptyStateSelection = _b[1];
    var handleChange = function (evt, onChange) {
        setOptionState(evt.target.value);
        setEmptyStateSelection(true);
        onChange && onChange(evt);
        if (placeholder && evt.target && evt.target.value !== placeholder) {
            evt.target.classList.remove('fds-field-select-placeholder');
        }
    };
    var restrictedProps = ['checked', 'className', 'disabled', 'name', 'onChange', 'type', 'value'];
    var attributes = FormComponentUtils_1.getFormControlAttributes(formControlProps, restrictedProps);
    var labelContent = (react_1.default.createElement("span", { className: classnames_1.default('fds-field-label', { secondary: !floatLabel && secondary }) }, visuallyHiddenLabel ? react_1.default.createElement(common_1.VisuallyHidden, null, label) : label));
    var placeholderValue = placeholder ? placeholder : '';
    var emptyStateValue = emptyState ? '' : placeholderValue;
    var defaultValue = optionState || emptyStateValue;
    return (react_1.default.createElement("label", { className: getClassNames(props, emptyStateSelection) },
        !floatLabel && labelContent,
        react_1.default.createElement("select", __assign({}, attributes, { className: classnames_1.default('fds-field-select', { 'fds-field-select-placeholder': !emptyState && placeholder }), disabled: disabled, name: name, onChange: function (e) { return handleChange(e, onChange); }, onBlur: onBlur, value: defaultValue }),
            (emptyState || placeholder) && (react_1.default.createElement("option", { disabled: true, value: emptyState ? '' : placeholder, className: "fds-field-select-dummy-option" }, emptyState ? '' : placeholder)),
            (optionList &&
                optionList.map(function (option) {
                    return (react_1.default.createElement("option", { disabled: option.disabled, key: option.optionId ? option.optionId : option.value, value: option.value }, option.text));
                })) || children),
        floatLabel && labelContent,
        react_1.default.createElement(ValidationMessage_1.default, { validationMessage: validationMessage, validationState: invalid ? FieldValidationState_1.FieldValidationState.INVALID : validationState })));
};
Select.defaultProps = {
    floatLabel: true
};
var getClassNames = function (props, emptyStateSelection) {
    var disabled = props.disabled, floatLabel = props.floatLabel, fullWidth = props.fullWidth, invalid = props.invalid, classes = props.classes, validationState = props.validationState, visuallyHiddenLabel = props.visuallyHiddenLabel, emptyState = props.emptyState, value = props.value;
    return classnames_1.default('fds-field', 'fds-field-select-label', {
        'is-disabled': disabled,
        'has-floated-label': floatLabel,
        'visually-hidden-label': visuallyHiddenLabel,
        'fds-form-control-full-width': fullWidth,
        invalid: invalid || validationState === FieldValidationState_1.FieldValidationState.INVALID,
        valid: validationState === FieldValidationState_1.FieldValidationState.VALID,
        'fds-field-select-empty-state': emptyState && !value && !emptyStateSelection
    }, classes);
};
exports.default = Select;
